import React, { PropsWithChildren } from "react";
import { LinkedAccountProvider } from "../../providers/LinkedAccountsProvider";
import { BankingData } from "./BankingData";
import { withUIProtection } from "../../hoc/withUIProtection";
import { LinkedAccount } from "./LinkedAccount";
import { BankingProvider } from "../../providers/BankingProvider";
import { CreditMemoContextProvider } from "../../providers/CreditMemoProvider";

type Props = PropsWithChildren & {
  asContainer?: boolean;
};

const Banking = ({ children, asContainer = true, ...rest }: Props) => {
  return (
    <LinkedAccountProvider {...rest}>
      <BankingProvider {...rest}>
        <CreditMemoContextProvider>
          <div data-name="banking">{children}</div>
        </CreditMemoContextProvider>
      </BankingProvider>
    </LinkedAccountProvider>
  );
};

const ProtectedLinkedAccounts = withUIProtection(LinkedAccount);
const ProtectedBankingData = withUIProtection(BankingData);

// Attach the protected subcomponents to the ProtectedPayment component
Banking.LinkedAccountsComponent = ProtectedLinkedAccounts;
Banking.BankingData = ProtectedBankingData;

export { Banking };

// Export individual protected components
export {
  ProtectedLinkedAccounts as LinkedAccountsComponent,
  ProtectedBankingData as BakingData,
};
